import http from './http';

export function fetchBillingDashboard() {
  return http.get('/billing/dashboard');
}
